export default __webpack_public_path__ + "static/media/supernova.5f6f313f.png";